import { FetchCollectionResult, FetchResultType } from '@/entities/FetchResult'
import { NotificationCenterHeaderName, NotificationCenterLog } from '@/entities/NotificationCenter/NotificationCenter'
import { authorizedFetch } from '@/helpers/authorizedFetch'
import { reportError, reportMessage } from '@/helpers/errorReporting'
import { trans } from '@/helpers/trans'
import { generateApiUrl } from '@/helpers/url'

import { CheckInRecord, CheckOutRecord } from './TrackRecord'
import { TrackRecordResponse } from './TrackRecordHelpers'
import { transformTrackRecordsToApiCallBody } from './TrackRecordTransformers'

export const putTrackRecordsApiCall = async (
    records: (CheckInRecord | CheckOutRecord)[],
    eventLogTrackerData: NotificationCenterLog,
): Promise<FetchCollectionResult<boolean, string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/api/v3/tracks/batch-insert',
        })

        const body = transformTrackRecordsToApiCallBody(records)

        const response = await authorizedFetch(url, {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        })

        const doc: TrackRecordResponse = await response.json()

        if (
            doc.status !== 200
            && doc.status !== 201
        ) {
            reportMessage('putTrackRecordsApiCall', `putTrackRecordsApiCall failed with HTTP status ${doc.status}`)

            return {
                status: doc.status,
                type: FetchResultType.Error,
                error: trans('errors.putTrackRecords'),
            }
        }

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: true,
        }
    } catch (error) {
        reportError('putTrackRecordsApiCall', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.putTrackRecords'),
        }
    }
}
